// priority = order of preference
// 0 is reserved for current card used by loan

const order = {
    A2: {
        priority: 1
    },
    B1: {
        priority: 2
    },
    B2: {
        priority: 3
    },
    B3: {
        priority: 4
    },
    B4: {
        priority: 5
    },
    C1: {
        priority: 6
    },
    A3: {
        priority: 99
    },
    A1: {
        priority: 99999 // likely to never be used again
    },
};

module.exports = order;
